export default {"src":"/org/_next/static/media/favicon.e2888f3d.ico","height":48,"width":48,"blurWidth":0,"blurHeight":0};